// extracted by mini-css-extract-plugin
export default {"tabs":"SelectorTabs_tabs__u9i6R","tab":"SelectorTabs_tab__PFgK5","activeTab":"SelectorTabs_activeTab__RWylb"};